import {Selection} from "../selections/models";

export class User {
  constructor(public name: string,
              public license: string,
              public university_name: string,
              public university_id: number,
              public can_compare: boolean,
              public show_tutorial: boolean,
              ) {
  }
}

export class Database {
  constructor(public id: number,
              public date: string,
              public system_ver: string,
              public universitiesCount: number,
              ) {
  }
}

export class Country {
  constructor(public id: number,
              public name: string,
              public continent: string,
              public eaes: boolean,
              public brics: boolean,
              public count: number) {
  }
}

export class University {
  constructor(public id: number,
              public name: string,
              public fullname: string,
              public country: number | string) {
  }
}

export class UniversityField {
  constructor(public value: string,
              public name: string,
              public type: string,
              public score_group: string,
              public group: string) {
  }
}

export class RankField {
  constructor(public name: string,
              public short_name: string,
              public year: number,
              public type: number,
              public type_name: string) {
  }
}

export class WidgetFilter {
  constructor(public type: string,
              public op: string,
              public val: string | boolean | number,
              public university: string,
              public indicators: [],
              public method: string,
              public indicatorsFilter: [],
              public count: string) {
  }
}

export class WidgetIndicator {

  constructor(
    public num: boolean,
    public form: boolean,
    public color: boolean,
    public split: boolean,
    public indicator: string,
    public indicator_type: string,
    public uni_x: string,
    public uni_y: string,
    public rating_weight: string,
    public rating_method: string,
    public rating_null: string,
    public group2: string,
    public group2_color: string,
    public group2_form: string,
    ) {
  }
}

export class Widget {
  constructor(
    public id: string,
    public name: string,
    public visualization: string,
    public selection: Selection | null,
    public selection_auto_update: boolean,
    public filters: WidgetFilter[],
    public benchmarks: any,
    public indicators: WidgetIndicator[],
    public settings: any,
    public grid: { x: number, y: number, cols: number, rows: number },
    public created_at: string,
    public updated_at: string,
    public chartRef?: any) {

  }

}


export class DashboardConf {

  constructor(public widgets: Widget[]) {
  }
}

export class Dashboard {

  constructor(public id: number,
              public name: string,
              public index: number,
              public conf: DashboardConf) {
  }
}

export class Visualization {

  constructor(public name: string,
              public icon: string,
              public description: string,
              public value: string,
              public indicatorsNum: number,
              public indicatorsCat: number,
              public indicatorsMax: number,
              public benchmarks: number,
              public benchmarksMax: number,
              public labels: any[],
              public settings: any[]) {
  }
}

// export class Filter {
//
//   constructor(public variable: string,
//               public op: string,
//               public val: string,
//               public university: string,
//               public indicators: string,
//               public method: string,
//               public indicatorsFilter: string,
//               public count: string) {
//   }
// }

export class TutorialSlide {
  constructor(public title: string,
              public body: string,
              public image: string,
              public video: string,
              public link: string,
              public order: string) {
  }
}

export interface GridItem {
  x: number,
  y: number,
  cols: number,
  rows: number,
}

export const bencmarkTypes = {
  'avg': 'среднее',
  'median': 'медиана',
  'percentile': 'перцентили',
  'min': 'минимум',
  'max': 'максимум',
  'value': 'значение',
  'free_value': 'произвольное значение',
  'university': 'значение университета',
  'topx': 'топ-Х значений',
};
